import styled from 'styled-components'
import {Link} from '../style'

export const FlexColumnStart = styled.div`
  display: flex;
  position: relative;
  flex-grow: 1;
  flex-direction: column; 
`
export const LinkInfoAreaSmartLead = styled.a`
  display: flex;
  flex-direction: column;
  text-decoration: none;
  padding-bottom: 24px;
`